import React from "react";

const ContactUs = ({}) => {
  return (
    <>
      <p className="text-dark h5 mb-4">Contact Us</p>

      <p name="about_us_description" className="my-5 mt-n1">
        Send us an email on <br />
        <b>admin@urgidoctor.com</b>
      </p>
    </>
  );
};

export default ContactUs;
